export function formatlongDate(dateVar: string) {
    // Parse the date with Eastern Time offset
    const parsedDate = parseDateInEastern(dateVar);
    
    if (isNaN(parsedDate.getTime())) {
        return 'Invalid Date';
    }
    
    return formatDateHelper(parsedDate);
}

export function formatDate(dateVar: string) {
    const parsedDate = parseDateInEastern(dateVar);
    
    if (isNaN(parsedDate.getTime())) {
        return 'Invalid Date';
    }
    
    return formatDateShortHelper(parsedDate);
}

// Helper function to parse dates in Eastern Time
function parseDateInEastern(dateVar: string): Date {
    // Try parsing as ISO date first
    let parsedDate = new Date(dateVar + 'T00:00:00');
    
    // If that fails, try without the time component
    if (isNaN(parsedDate.getTime())) {
        parsedDate = new Date(dateVar);
    }
    
    // If still invalid, return as is
    if (isNaN(parsedDate.getTime())) {
        return parsedDate;
    }
    
    // Get the UTC time
    const utcTime = parsedDate.getTime();
    
    // Get the timezone offset for the user's current location
    const userOffset = parsedDate.getTimezoneOffset() * 60000; // Convert to milliseconds
    
    // Eastern Time offset: EST is UTC-5, EDT is UTC-4
    // We'll use a simple check: if the date falls in DST period, use -4, otherwise -5
    const easternOffset = getEasternOffset(parsedDate);
    
    // Adjust to Eastern Time
    const easternTime = utcTime + userOffset + (easternOffset * 3600000);
    
    return new Date(easternTime);
}

// Determine if a date is in Eastern Daylight Time (EDT) or Eastern Standard Time (EST)
function getEasternOffset(date: Date): number {
    const year = date.getFullYear();
    
    // DST starts second Sunday in March at 2 AM
    const dstStart = new Date(year, 2, 1); // March 1
    dstStart.setDate(1 + (7 - dstStart.getDay()) % 7 + 7); // Second Sunday
    dstStart.setHours(2, 0, 0, 0);
    
    // DST ends first Sunday in November at 2 AM
    const dstEnd = new Date(year, 10, 1); // November 1
    dstEnd.setDate(1 + (7 - dstEnd.getDay()) % 7); // First Sunday
    dstEnd.setHours(2, 0, 0, 0);
    
    // Check if date falls within DST period
    if (date >= dstStart && date < dstEnd) {
        return -4; // EDT (UTC-4)
    } else {
        return -5; // EST (UTC-5)
    }
}

function formatDateHelper(parsedDate: Date) {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const days = ['Sun','Mon','Tue','Wed', 'Thu', 'Fri', 'Sat'];
    const dow = days[parsedDate.getDay()];
    const month = months[parsedDate.getMonth()];
    const day = parsedDate.getDate();
    const year = parsedDate.getFullYear();
    return `${dow}, ${month} ${day}, ${year}`;
}

function formatDateShortHelper(parsedDate: Date) {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const month = months[parsedDate.getMonth()];
    const day = parsedDate.getDate();
    const year = parsedDate.getFullYear();
    return `${month} ${day}, ${year}`;
}

export function formatTime(timeVar: string){
    const hours: number = Number(timeVar.substring(0,2));
    const minutes: string = timeVar.substring(3,5);
    let newHours;
    let extra = "PM";
    
    if(hours > 12){
        newHours = hours - 12;
    } else if(hours === 0) {
        newHours = 12;
        extra = "AM";
    } else if(hours === 12) {
        newHours = 12;
        extra = "PM";
    } else {
        newHours = hours;
        extra = "AM";
    }
    
    return `${newHours}:${minutes} ${extra}`;
}